// Simple authProvider for zWarehouse
// This replaces the AWS authentication with a simple username/password system
// Credentials are loaded from environment variables

import { getCredentials } from './config/auth';

const authProvider = {
    // Called when the user attempts to log in
    login: ({ username, password }) => {
        // Get credentials from environment variables
        const credentials = getCredentials();

        if (username === credentials.username && password === credentials.password) {
            // Store user info in localStorage
            localStorage.setItem('zWarehouseUser', JSON.stringify({
                id: credentials.username,
                username: credentials.username,
                role: 'admin', // Single user is always admin
                fullName: credentials.username.charAt(0).toUpperCase() + credentials.username.slice(1),
                email: `${credentials.username}@schoolstart.ca`
            }));
            return Promise.resolve();
        }

        return Promise.reject(new Error('Invalid username or password'));
    },

    // Called when the user clicks on the logout button
    logout: () => {
        localStorage.removeItem('zWarehouseUser');
        return Promise.resolve();
    },

    // Called when the API returns an error
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('zWarehouseUser');
            return Promise.reject();
        }
        return Promise.resolve();
    },

    // Called when the user navigates to a new location, to check for authentication
    checkAuth: (params) => {
        const user = localStorage.getItem('zWarehouseUser');
        if (user) {
            return Promise.resolve();
        }
        return Promise.reject();
    },

    // Called when the user navigates to a new location, to check for permissions / roles
    getPermissions: (params) => {
        const user = localStorage.getItem('zWarehouseUser');
        if (user) {
            const userData = JSON.parse(user);
            return Promise.resolve(userData.role);
        }
        return Promise.reject();
    },

    // Get the user identity
    getIdentity: () => {
        const user = localStorage.getItem('zWarehouseUser');
        if (user) {
            const userData = JSON.parse(user);
            return Promise.resolve({
                id: userData.id,
                fullName: userData.fullName,
                avatar: undefined
            });
        }
        return Promise.reject();
    }
};

export default authProvider; 